export async function restRequest(url, method, body, token, query) {
    let queryString = '';
    if (query && query.length > 0) {
        queryString =
            '?' + query.map((param) => `${encodeURIComponent(param.name)}=${encodeURIComponent(param.value)}`).join('&');
    }
    const rawResponse = await fetch(url + queryString, {
        headers: Object.assign({ Accept: 'application/json', 'Content-Type': 'application/json' }, (token && { Authorization: 'Bearer ' + token })),
        method,
        body: JSON.stringify(body),
    });
    if (!rawResponse.ok) {
        if (rawResponse.status == 401 || rawResponse.status === 403) {
            throw { code: 'UNAUTHORIZED' };
        }
        throw { code: 'METHOD_ERROR', message: 'Bad response from service.' };
    }
    const response = await rawResponse.json();
    return response;
}
//# sourceMappingURL=rest.js.map